function getCountLabel(action, count) {
  return `${action} (${count}) selected card${count === 1 ? "" : "s"}`;
}

export default function WantsSelectionActions({
  selectedCards,
  hasSelectedCards,
  hasSelectedStacks,
  selectedCount,
  onSplit,
  onRemove,
}) {
  if (selectedCards.length === 0) {
    return null;
  }

  return (
    <div
      style={{
        position: "fixed",
        right: "24px",
        bottom: "76px",
        display: "flex",
        flexDirection: "column",
        gap: "10px",
        zIndex: 1001
      }}
    >
      <button
        style={{
          padding: "12px 18px",
          background: hasSelectedStacks ? "#455a64" : "#b0bec5",
          color: "white",
          border: "none",
          borderRadius: "10px",
          cursor: hasSelectedStacks ? "pointer" : "not-allowed",
          fontSize: "14px",
          fontWeight: 600,
          boxShadow: hasSelectedStacks ? "0 10px 24px rgba(69,90,100,0.28)" : "none"
        }}
        onClick={onSplit}
        disabled={!hasSelectedStacks}
      >
        Split selected cards
      </button>
      <button
        style={{
          padding: "12px 18px",
          background: hasSelectedCards ? "#c62828" : "#ef9a9a",
          color: "white",
          border: "none",
          borderRadius: "10px",
          cursor: hasSelectedCards ? "pointer" : "not-allowed",
          fontSize: "14px",
          fontWeight: 600,
          boxShadow: hasSelectedCards ? "0 10px 24px rgba(198,40,40,0.28)" : "none"
        }}
        onClick={onRemove}
        disabled={!hasSelectedCards}
      >
        {getCountLabel("Remove", selectedCount)}
      </button>
    </div>
  );
}